import type { Brand } from "./brands";
import type { SidebarNavItem } from "@/components/theme/layout/app/SidebarNav.vue";

export type SidebarNav = {
  main: SidebarNavItem[];
} & {
  [key in Brand]?: SidebarNavItem[];
};

export const defaultSidebarNav: SidebarNav = {
  main: [
    { title: "inicio", icon: "objects", to: "/dashboard" },
    { title: "estado_de_pedidos", icon: "eye", to: "/lentes/pedidos" },
    { title: "recogidas", icon: "delivery-truck-pin", to: "/lentes/recogidas" },
    { title: "devoluciones", icon: "bin-box-arrow-up", to: "/lentes/devoluciones" },
    { title: "bienes_de_equipo", icon: "gears", to: "/bienes-de-equipo" },
    { title: "notificaciones", icon: "notifications", to: "/notificaciones" },
    { title: "ajustes", icon: "settings-nav", to: "/settings/optic-data" },
    // "descargas" se muestra ahora como subopción dentro de "ajustes" (ver Sidebar.vue)
    // { title: "descargas", icon: "download-arrow", to: "/descargas" },
  ],
};
